export const ta = {
  // Navigation (Tamil)
  explore: 'ஆராய்',
  search: 'தேடு',
  create: 'பதிவு உருவாக்கு',
  messages: 'செய்திகள்',
  notifications: 'அறிவிப்புகள்',
  settings: 'அமைப்புகள்',
  profile: 'சுயவிவரம்',
  logout: 'வெளியேறு',
  home: 'முகப்பு',
  
  // Authentication
  signin: 'உள்நுழை',
  signup: 'பதிவு செய்',
  login: 'உள்நுழைவு',
  register: 'பதிவு',
  email: 'மின்னஞ்சல்',
  password: 'கடவுச்சொல்',
  confirmPassword: 'கடவுச்சொல்லை உறுதிப்படுத்து',
  firstName: 'முதல் பெயர்',
  lastName: 'கடைசி பெயர்',
  forgotPassword: 'கடவுச்சொல்லை மறந்துவிட்டீர்களா?',
  alreadyHaveAccount: 'ஏற்கனவே கணக்கு உள்ளதா? உள்நுழையவும்',
  dontHaveAccount: 'கணக்கு இல்லையா? பதிவு செய்யவும்',
  
  // Posts & Content
  recent: 'சமீபத்திய',
  trending: 'டிரெண்டிங்',
  popular: 'பிரபலமான',
  like: 'விருப்பம்',
  likes: 'விருப்பங்கள்',
  comment: 'கருத்து',
  comments: 'கருத்துகள்',
  share: 'பகிர்',
  delete: 'நீக்கு',
  edit: 'திருத்து',
  post: 'பதிவு',
  posts: 'பதிவுகள்',
  title: 'தலைப்பு',
  content: 'உள்ளடக்கம்',
  tags: 'குறிச்சொற்கள்',
  noBlogsFound: 'வலைப்பதிவுகள் எதுவும் கிடைக்கவில்லை। வேறு ஏதாவது தேட முயற்சிக்கவும் அல்லது முதலாவதை உருவாக்கவும்!',
  
  // AI Assistant
  quickActions: 'விரைவு செயல்கள்',
  writeCaption: 'தலைப்பு எழுது',
  suggestTopics: 'தலைப்புகளை பரிந்துரை செய்',
  improveContent: 'உள்ளடக்கத்தை மேம்படுத்து',
  creativeIdeas: 'படைப்பு யோசனைகள்',
  clearChat: 'அரட்டையை அழி',
  aiWritingAssistant: 'AI எழுத்து உதவியாளர்',
  poweredByGroq: 'GROQ AI ஆல் இயக்கப்படுகிறது',
  aiGreeting: 'வணக்கம்! நான் உங்கள் AI எழுத்து உதவியாளர். நான் உங்களுக்கு ஈர்க்கக்கூடிய உள்ளடக்கத்தை உருவாக்க, தலைப்புகள் எழுத, பதிவு தலைப்புகளை பரிந்துரைக்க மற்றும் உங்கள் எழுத்தை மேம்படுத்த உதவ முடியும். இன்று நீங்கள் எதில் வேலை செய்ய விரும்புகிறீர்கள்?',
  askMeToHelp: 'உள்ளடக்கம், தலைப்புகள், தலைப்புகள் அல்லது எழுத்துக்கு உதவி கேளுங்கள்...',
  aiThinking: 'AI சிந்திக்கிறது...',
  
  // Chat & Messages
  chat: 'அரட்டை',
  noConversationsYet: 'இன்னும் உரையாடல்கள் இல்லை',
  ideafluxChat: 'IdeaFlux அரட்டை',
  typeMessage: 'செய்தியை தட்டச்சு செய்யவும்...',
  sendMessage: 'செய்தி அனுப்பு',
  connectingToChat: 'அரட்டையுடன் இணைக்கிறது...',
  
  // Notifications
  noNotificationsYet: 'இன்னும் அறிவிப்புகள் இல்லை।',
  markAllRead: 'அனைத்தையும் படித்ததாக குறி',
  clearAll: 'அனைத்தையும் அழி',
  
  // Settings
  accountSettings: 'கணக்கு அமைப்புகள்',
  displayName: 'காட்சி பெயர்',
  emailAddress: 'மின்னஞ்சல் முகவரி',
  languagePreference: 'மொழி விருப்பம்',
  privacySecurity: 'தனியுரிமை மற்றும் பாதுகாப்பு',
  notificationPreferences: 'அறிவிப்பு விருப்பங்கள்',
  allowDirectMessages: 'நேரடி செய்திகளை அனுமதி',
  letOthersMessage: 'மற்ற பயனர்கள் உங்களுக்கு தனிப்பட்ட செய்திகள் அனுப்ப அனுமதிக்கவும்',
  likesOnPosts: 'பதிவுகளில் விருப்பங்கள்',
  commentsOnPosts: 'பதிவுகளில் கருத்துகள்',
  newFollowers: 'புதிய பின்தொடர்பவர்கள்',
  mentions: 'குறிப்பிடுகள்',
  save: 'சேமி',
  deleteAccount: 'கணக்கை நீக்கு',
  
  // Notification descriptions
  getNotifiedWhenSomeone: 'யாராவது இருக்கும்போது அறிவிப்பு பெறுங்கள்',
  likesYourPosts: 'உங்கள் பதிவுகளை விரும்புகிறார்கள்',
  commentsOnYourPosts: 'உங்கள் பதிவுகளில் கருத்து தெரிவிக்கிறார்கள்',
  followsYou: 'உங்களை பின்தொடர்கிறார்கள்',
  mentionsYou: 'உங்களை குறிப்பிடுகிறார்கள்',
  chooseNotifications: 'நீங்கள் எந்த அறிவிப்புகளை பெற விரும்புகிறீர்கள் என்பதை தேர்வு செய்யுங்கள்',
  controlWhoInteracts: 'உங்களுடன் யார் தொடர்பு கொள்ளலாம் என்பதை கட்டுப்படுத்துங்கள்',
  manageAccountInfo: 'உங்கள் கணக்கு தகவல் மற்றும் விருப்பங்களை நிர்வகிக்கவும்',
  emailCannotBeChanged: 'பாதுகாப்பு காரணங்களுக்காக மின்னஞ்சலை மாற்ற முடியாது',
  
  // Common
  loading: 'ஏற்றுகிறது...',
  cancel: 'ரத்து செய்',
  update: 'புதுப்பி',
  submit: 'சமர்ப்பி',
  back: 'பின்னால்',
  next: 'அடுத்து',
  previous: 'முந்தைய',
  online: 'ஆன்லைன்',
  offline: 'ஆஃப்லைன்',
  
  // Profile
  editProfile: 'சுயவிவரத்தை திருத்து',
  noBioYet: 'இன்னும் சுயவிவரம் இல்லை।',
  followers: 'பின்தொடர்பவர்கள்',
  following: 'பின்தொடர்கிறது',
  recentActivity: 'சமீபத்திய செயல்பாடு',
  noPostsYet: 'இன்னும் பதிவுகள் இல்லை',
  shareFirstPost: 'உங்கள் முதல் பதிவைப் பகிரவும்!',
  bio: 'சுயவிவரம்',
  dateOfBirth: 'பிறந்த தேதி',
  follow: 'பின்தொடர்',
  unfollow: 'பின்தொடராதே',
  
  // Search
  discover: 'கண்டுபிடி',
  findPeopleStories: 'உங்களுக்கு முக்கியமான மக்கள், கதைகள் மற்றும் யோசனைகளைக் கண்டறியவும்',
  searchByName: 'பெயர், தலைப்பு அல்லது #குறிச்சொல் மூலம் தேடவும்...',
  searchResults: 'தேடல் முடிவுகள்',
  noResultsFound: 'முடிவுகள் எதுவும் கிடைக்கவில்லை',
  peopleFound: 'மக்கள் கண்டுபிடிக்கப்பட்டனர்',
  
  // Settings - Additional keys
  enterDisplayName: 'உங்கள் காட்சி பெயரை உள்ளிடவும்',
  saving: 'சேமிக்கிறது...',
  confirmDeleteAccount: 'நீங்கள் உங்கள் கணக்கை நீக்க விரும்புகிறீர்களா? இதை செயல்தவிர்க்க முடியாது.',
  accountDeletedSuccessfully: 'கணக்கு வெற்றிகரமாக நீக்கப்பட்டது.',
  errorDeletingAccount: 'கணக்கை நீக்குவதில் பிழை. மீண்டும் முயற்சிக்கவும்.',
  settingsSavedSuccessfully: 'அமைப்புகள் வெற்றிகரமாக சேமிக்கப்பட்டன!',
  failedToSaveSettings: 'அமைப்புகளை சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
  
  // Form component
  pleaseSignInToCreate: 'பதிவு உருவாக்க உள்நுழையவும்।',
  titleRequired: 'பதிவு வெளியிட தலைப்பு தேவை।',
  contentRequired: 'பதிவு வெளியிட கதை உள்ளடக்கம் தேவை।',
  contentTooShort: 'கதை உள்ளடக்கம் குறைந்தது 10 எழுத்துகள் நீளமாக இருக்க வேண்டும்.',
  postUpdatedSuccessfully: 'பதிவு வெற்றிகரமாக புதுப்பிக்கப்பட்டது!',
  postPublishedSuccessfully: 'பதிவு வெற்றிகரமாக வெளியிடப்பட்டது!',
  pleaseSignInToCreateBlogs: 'உங்கள் சொந்த IdeaFlux வலைப்பதிவுகளை உருவாக்க உள்நுழையவும்.',
  enterEngagingTitle: 'ஈர்க்கக்கூடிய தலைப்பை உள்ளிடவும்...',
  story: 'கதை',
  writeYourMasterpiece: 'உங்கள் தலைசிறந்த படைப்பை எழுதுங்கள்...',
  addTags: 'குறிச்சொற்களை சேர்...',
  add: 'சேர்',
  publishPost: 'பதிவை வெளியிடு',
  
  // Post component
  linkCopiedToClipboard: 'இணைப்பு கிளிப்போர்டுக்கு நகலெடுக்கப்பட்டது! பகிர்வு எண்ணிக்கை புதுப்பிக்கப்பட்டது.',
  youAndOthers: 'நீங்கள் மற்றும் {{count}} மற்றவர்கள்',
  unknownUser: 'அறியப்படாத பயனர்',
  noImage: 'படம் இல்லை',
  deletePost: 'பதிவை நீக்கு',
  confirmDeletePost: 'இந்த பதிவை நீக்க விரும்புகிறீர்களா?',
};